export default {
  "root": "_root_1fpv8_1",
  "--type-literal": "_--type-literal_1fpv8_1",
  "--type-unit": "_--type-unit_1fpv8_1",
  "--type-literal--m": "_--type-literal--m_1fpv8_1",
  "--type-unit--m": "_--type-unit--m_1fpv8_1",
  "--type-literal--l": "_--type-literal--l_1fpv8_1",
  "--type-unit--l": "_--type-unit--l_1fpv8_1",
  "--type-literal--xl": "_--type-literal--xl_1fpv8_1",
  "--type-unit--xl": "_--type-unit--xl_1fpv8_1"
};import "ni:sha-256;yQK1neJk16X5_sPE2uGcdC0CuzBf54XOyrYlMnwTgjc";